export default __webpack_public_path__ + "static/media/hamburger_dk.6572e529.svg";